import React, { useState as classicUseState } from 'react';

import { useMutation } from 'react-query';

import { State } from '@hookstate/core';
import { withStyles } from '@material-ui/core';
import Checkbox, { CheckboxProps } from '@material-ui/core/Checkbox';

import { SearchBarExpansive } from '@components';
import { getProductModels } from '@services/queries/products';
import { getManufacturersNames } from '@services/queries/manufacturers';
import {
  CheckCircle,
  UncheckCircle,
} from '@pages/Products/components/AddEquipmentModal/components/components.styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import CloseImage from '@assets/svg/close-ticket.svg';

import {
  Container,
  Label,
  Header,
  Buttons,
  Confirm,
  Line,
  FilterDiv,
  FilterText,
  Cancel,
  WindowButton,
  WindowButtonImage,
} from './FilterProductContent.styles';
import { IProductFilterData } from '../../types';

export const BlueCheckbox = withStyles({
  root: {
    color: '#1371FE',
    '&$checked': {
      color: '#1371FE',
    },
    height: '18px',
    width: '18px',
  },
  checked: {},
})((props: CheckboxProps) => <Checkbox color="default" {...props} />);

interface IAddFieldContent {
  openAddField: State<boolean>;
  filterData: IProductFilterData;
  startSearch: () => void;
  setFilterData: (newFilter: IAddFieldContent['filterData']) => void;
  filterCount: number;
}

const FilterProductContent = ({
  openAddField,
  filterData,
  startSearch,
  setFilterData,
  filterCount,
}: IAddFieldContent) => {
  const [searchTextModel, setSearchTextModel] = classicUseState('');
  const [loadingSearchModel, setLoadingSearchModel] = classicUseState(false);
  const [alreadySearchModel, setAlreadySearchModel] = classicUseState(false);
  const [showErasedSearchModel, setShowErasedSearchModel] =
    classicUseState(false);
  const [searchTextManufactor, setSearchTextManufactor] = classicUseState('');
  const [loadingSearchManufactor, setLoadingSearchManufactor] =
    classicUseState(false);
  const [alreadySearchManufactor, setAlreadySearchManufactor] =
    classicUseState(false);
  const [showErasedSearchManufactor, setShowErasedManufactor] =
    classicUseState(false);
  const [models, setModels] = classicUseState<string[]>([]);
  const [manufactorNames, setManufactorNames] = classicUseState<string[]>([]);

  const mutationGetProductModels = useMutation(getProductModels, {
    onSuccess: result => {
      setLoadingSearchModel(false);
      setShowErasedSearchModel(true);
      setAlreadySearchModel(true);
      setModels(result.map(item => item.model));
    },
  });

  const mutationGetManufactorsNames = useMutation(getManufacturersNames, {
    onSuccess: result => {
      setLoadingSearchManufactor(false);
      setShowErasedManufactor(true);
      setAlreadySearchManufactor(true);
      setManufactorNames(result.map(item => item.name));
    },
  });

  const startSearchModel = (input: string) => {
    setLoadingSearchModel(true);
    mutationGetProductModels.mutate(input);
  };

  const startSearchManufactor = (input: string) => {
    setLoadingSearchManufactor(true);
    mutationGetManufactorsNames.mutate(input);
  };

  const onPressEnterModel = (event: any) => {
    if (event.key === 'Enter') {
      startSearchModel(searchTextModel);
    }
  };

  const onPressEnterManufactor = (event: any) => {
    if (event.key === 'Enter') {
      startSearchManufactor(searchTextManufactor);
    }
  };

  const searchFuncModel = (input: string) => {
    setShowErasedSearchModel(false);
    setSearchTextModel(input);
  };
  const searchFuncManufactor = (input: string) => {
    setShowErasedManufactor(false);
    setSearchTextManufactor(input);
  };

  return (
    <Container>
      <Header>
        Filter by
        <WindowButton
          onClick={() => {
            openAddField.set(false);
          }}
        >
          <WindowButtonImage src={CloseImage} />
        </WindowButton>
      </Header>
      <Label> Model #</Label>
      <Line />
      <SearchBarExpansive
        showOptions={models}
        setShowOptions={setModels}
        searchText={searchTextModel}
        placeholder="Find a Model #"
        loadingSearch={loadingSearchModel}
        alreadySearch={alreadySearchModel}
        showErasedSearch={showErasedSearchModel}
        searchOnKeyDown={onPressEnterModel}
        searchOnChange={searchFuncModel}
        searchIconOnClick={() => startSearchModel(searchTextModel)}
        closeIconOnClick={() => {
          searchFuncModel('');
          startSearchModel('');
        }}
        onClickFilter={input => {
          const newFilterData = { ...filterData };
          const filterExist = newFilterData.modelsName.find(item =>
            item.name.match(input),
          );
          if (!filterExist) {
            newFilterData.modelsName.push({ name: input, active: true });
            setFilterData(newFilterData);
          }
          setModels([]);
        }}
      />
      {filterData.modelsName.map(model => (
        <FilterDiv>
          <FormControlLabel
            control={
              <BlueCheckbox
                icon={<UncheckCircle />}
                checkedIcon={<CheckCircle />}
                name="checkedH"
              />
            }
            label=""
            checked={model.active}
            onClick={() => {
              const newFilterData = { ...filterData };
              newFilterData.manufactorNames = filterData.modelsName.filter(
                item => item.name !== model.name,
              );
              setFilterData(newFilterData);
            }}
          />
          <FilterText>{model.name}</FilterText>
        </FilterDiv>
      ))}
      <div style={{ height: 9 }} />
      <Label>Manufacturer</Label>
      <Line />
      <SearchBarExpansive
        showOptions={manufactorNames}
        setShowOptions={setManufactorNames}
        searchText={searchTextManufactor}
        placeholder="Find a Manufacturer"
        loadingSearch={loadingSearchManufactor}
        alreadySearch={alreadySearchManufactor}
        showErasedSearch={showErasedSearchManufactor}
        searchOnKeyDown={onPressEnterManufactor}
        searchIconOnClick={() => startSearchManufactor(searchTextManufactor)}
        closeIconOnClick={() => {
          searchFuncManufactor('');
          startSearchManufactor('');
        }}
        searchOnChange={searchFuncManufactor}
        onClickFilter={input => {
          const newFilterData = { ...filterData };
          const filterExist = newFilterData.manufactorNames.find(item =>
            item.name.match(input),
          );
          if (!filterExist) {
            newFilterData.manufactorNames.push({ name: input, active: true });
            setFilterData(newFilterData);
          }
          setManufactorNames([]);
        }}
      />
      {filterData.manufactorNames.map(manufactor => (
        <FilterDiv>
          <FormControlLabel
            control={
              <BlueCheckbox
                icon={<UncheckCircle />}
                checkedIcon={<CheckCircle />}
                name="checkedH"
              />
            }
            label=""
            checked={manufactor.active}
            onClick={() => {
              const newFilterData = { ...filterData };
              newFilterData.manufactorNames =
                newFilterData.manufactorNames.filter(
                  item => item.name !== manufactor.name,
                );
              setFilterData(newFilterData);
            }}
          />
          <FilterText>{manufactor.name}</FilterText>
        </FilterDiv>
      ))}
      <div style={{ height: 9 }} />
      <Buttons>
        {filterCount > 0 && (
          <Cancel
            onClick={() => {
              const newFilterData = { ...filterData };
              newFilterData.modelsName = [];
              newFilterData.manufactorNames = [];
              setFilterData(newFilterData);
            }}
          >
            Clear
          </Cancel>
        )}
        <div style={{ width: 16 }} />
        <Confirm
          active
          onClick={() => {
            openAddField.set(false);
            startSearch();
          }}
        >
          Confirm
        </Confirm>
      </Buttons>
    </Container>
  );
};

export { FilterProductContent };
